import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import { useSyncExternalStore } from "react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const mobileQuery = "(max-width: 639px)";
const subscribe = (cb: () => void) => {
  const mql = window.matchMedia(mobileQuery);
  mql.addEventListener("change", cb);
  return () => mql.removeEventListener("change", cb);
};
const getSnapshot = () => window.matchMedia(mobileQuery).matches;
const getServerSnapshot = () => false;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const isMobile = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  return (
    <Sonner
      position={isMobile ? "top-center" : "bottom-right"}
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          icon: "text-primary size-6!",
          title: "text-white font-semibold",
          description: "text-gray-400",
          actionButton: "bg-white text-black hover:bg-gray-200",
          cancelButton: "bg-gray-800 text-gray-300 hover:bg-gray-700",
          error: "bg-black text-red-400 border-red-900",
          success: "bg-black text-green-400 border-green-900",
          warning: "bg-black text-yellow-400 border-yellow-900",
          info: "bg-black text-blue-400 border-blue-900",
        },
      }}
      icons={{
        success: <CircleCheckIcon className="size-6" />,
        info: <InfoIcon className="size-6" />,
        warning: <TriangleAlertIcon className="size-6" />,
        error: <OctagonXIcon className="size-6" />,
        loading: <Loader2Icon className="size-6 animate-spin" />,
      }}
      {...props}
    />
  );
};

export { Toaster };
